module.exports = __webpack_public_path__ + "static/login_screen-15deb3a2b015f9824905d639ee836f87.png";